import BoundariesGridRowWrapper from '../BoundariesGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const BoundariesGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <BoundariesGridRowWrapper ref={ref} testId={testId}>
        {children}
    </BoundariesGridRowWrapper>
);

export default BoundariesGridHeader;
